<template>
  <div>
    <SPreloader />
    <SSubHeader :pageName="'Notifications'" />
    <div class="header-spacer--standard"></div>

    <div class="publish-content">
      <div class="container">
        <div class="row">
          <LoadingSpinner position="absolute" v-if="isFetchingActivityPage" />
          <div
            class="content-container"
            v-else
          >
            <SFilterBar
              class="filter-bar"
              id="filter-bar-activity"
              @postSearch="makePostSearch"
              @clearFilter="clearFilter"
              @removeFilter="removeFilter"
              :options="[optionsPosts]"
              :choice="choice"
              :selectedFilters="selectedFilters"
              :startWith="startOption"
              selectName="Filter"
              outsideLabel="Filter"
              ref="filterbar"
              :isItemActivity="true"
              :showMyPosts="this.state === 'showMyPosts'"
            />
            <div class="content-display">
              <div class="notifications-list">
                <NotificationsList
                v-for="notification in this.activityNotifications" :key=notification.id
                ref="requestsDropdown"
                :notification="notification"
                :text="setNotificationText(notification)"
              />
              </div>
              <ReferFriendsCTA class="mb-4 cta-on-notification" />
            </div>

          </div>
        </div>
      </div>
    </div>


    <a class="back-to-top arrow-top" href="#" v-if="pageBottom">
      <img src="/svg-icons/back-to-top.svg" alt="arrow" class="back-icon" />
    </a>
    <Footer/>
  </div>
</template>

<script>

import ItemHelperVue from "../../mixins/ItemHelper.vue";
import UserHelperVue from "../../mixins/UserHelper.vue";
import ChatHelperVue from "../../mixins/ChatHelper.vue";
import SPreloader from "@/components/organisms/SPreloader.vue";
import PointsHelperVue from "../../mixins/PointsHelper.vue";
import SSubHeader from "@/material-components/organisms/SSubHeader.vue";
import ReferFriendsCTA from "@/material-components/atoms/ReferFriendsCTA.vue";
import SFilterBar from "@/components/molecules/SFilterBar";
import itemType from "@/enum/item-type";
import itemStatus from "@/enum/item-status";
import NotificationsList from "@/components/organisms/NotificationsList";
import uniqid from "uniqid";
import LoadingSpinner from "@/material-components/atoms/LoadingSpinner.vue";
import Footer from "@/templates/Footer";

export default {
  name: "NotificationArea",
  mixins: [ItemHelperVue, UserHelperVue, ChatHelperVue, PointsHelperVue],
  components: {
    SPreloader,
    SSubHeader,
    ReferFriendsCTA,
    SFilterBar,
    NotificationsList,
    Footer,
    LoadingSpinner,
  },
  data() {
    return {
      itemUpdatedStatus: false,
      state: "showMyPosts",
      filter: {
        options: [],
        optionsPost: [],
      },
      optionsPosts: [
        { label: "Unseen", value: itemType.GIVE, dataCy: "unseenFilter" },
        { label: "Item", value: itemType.RECEIVE, dataCy: "itemFilter" },
        { label: "Group", value: itemType.RECEIVE, dataCy: "groupFilter" },
        { label: "Garage sale", value: itemType.RECEIVE, dataCy: "gsFilter" },
      ],
      choice: {
        options: [],
        optionsPost: [],
        optionsRequest: [],
      },
      startOption: null,
    };
  },
  methods: {
    makePostSearch(value) {
      this.filter.optionsPost = [...value.optionsPost];
    },
    clearFilter() {
      this.choice = {
        options: [],
        optionsPost: [],
      };
      this.filter = {
        options: [],
        optionsPost: [],
      };
    },
    removeFilter({ value,  dataCy }) {
      const secondToRemove = value === 1 ? 3 : value === 2 ? 4 : 0
      if (dataCy === 'receiveFilter' || dataCy === 'giveFilter') {
        this.choice.optionsPost = this.choice.optionsPost.filter((filter) => {
        return filter !== value && filter !== secondToRemove;
      });
      }
    },
    notifications() {
      const userNotifications = this.validateArray(this.activityNotifications.filter((notification)=> notification.seen === 0 ));
      return userNotifications.filter((notif) => {
        const today = new Date();
        let d10 = new Date(notif.changeSituationAt);
        let d20 = new Date(notif.changeSituationAt);
        switch (notif.notification) {
          case "new-request":
          case "accepted":
          case "rejected":
            if (!notif.seen) return notif;
            break;
          case "pending":
            d10.setDate(d10.getDate() + 10);
            d20.setDate(d20.getDate() + 20);
            if (
              !notif.sentSeen &&
              today >= d10 &&
              notif.item.status === itemStatus.WAITING
            ) {
              if (this.mountNotif(notif, 'GIVE', 'LEND', 'RECEIVE', 'BORROW')) return true
            }
            if (
              !notif.receivedSeen &&
              today >= d20 &&
              (notif.item.status === itemStatus.SENT ||
                notif.item.status === itemStatus.WAITING)
            ) {
              if (this.mountNotif(notif, 'RECEIVE', 'BORROW', 'GIVE', 'LEND')) return true
            }
            break;
        }
      });
    },
    setNotificationText(notification){
      let notificationType="request";
      if (notification.item.type === itemType.RECEIVE || notification.item.type === itemType.BORROW)
            notificationType = "offer"
      let shipStatus="receive";
      switch (notification.notification) {
        case "new-request":
          return `You have a new ${notificationType} for the item ${notification.item.title}`;
        case "accepted":
          return `Your ${notificationType} has been accepted for the item ${notification.item.title}`;
        case "pending":
          if (notification.item.posterId === this.loggedUser.id) {
            if (
              notification.item.type === itemType.GIVE ||
              notification.item.type === itemType.LEND
            ) {
              shipStatus = "send";
            }
          } else {
            if (
              notification.item.type === itemType.RECEIVE ||
              notification.item.type === itemType.BORROW
            ) {
              shipStatus = "send";
            }
          }
          return `Did you ${shipStatus} the item ${notification.item.title}?`;
        case "rejected":
          return `Your ${notificationType} has been rejected for the item ${notification.item.title}`
        default:
          return""
      }
    },
  },

  created() {
    this.fetchUserInventory(localStorage.getItem("user_id"));
    document.addEventListener("click", (event) => {
      if (
        !$(event.target).closest(".modal-content").length &&
        $("#accept").is(":visible")
      ) {
        this.closeModal();
      }
    });
  },
  watch: {
    $route(to, from) {
      if (to.query !== from.params) {
        if (
          this.$route.query.filter &&
          this.$route.query.filter === "incoming"
        ) {
          this.startOption = "incoming";
        }
      }
    },
    filteredResults(newValue) {
      if (newValue) {
        if (!this.itemUpdatedStatus) {
          this.setFetchingActivityPage(true);
          setTimeout(() => {
            this.setFetchingActivityPage(false);
          }, 1001);
        }
        this.itemUpdatedStatus = false;
      }
    },
    'filter.optionsPost': function (newValue) {
      if (newValue.includes(1) && !newValue.includes(3)) this.filter.optionsPost.push(3)
      if (newValue.includes(2) && !newValue.includes(4)) this.filter.optionsPost.push(4)

      if (newValue.includes(3) && !newValue.includes(1)) this.filter.optionsPost.splice(this.filter.optionsPost.indexOf(3), 1)
      if (newValue.includes(4) && !newValue.includes(2)) this.filter.optionsPost.splice(this.filter.optionsPost.indexOf(4), 1)

    },
  },
  computed: {
    showEmptyMessage() {
      return !this.filteredResults || this.filteredResults.length === 0;
    },
    inRequestsTab() {
      return this.state === "showMyRequests";
    },
    selectedFilters() {
      let filters = [];
      if (this.state === "showMyPosts") {
        this.optionsPosts.forEach((filter) => {
          if (this.choice.optionsPost.includes(filter.value) && filter.value !== "")
            filters.push(filter);
        });
      }
      return filters;
    },
    filteredPostsResults() {
      let merged = [];

      
        if (this.userInventoryWithRequests.length > 0) {
          merged = merged.concat([...this.userInventoryWithRequests]);
        }
      

      let result = [];
      let feedType;

      feedType = this.state === "showMyRequests" ? "requests" : "posts";
      
        let req = [];
        req = merged.filter((element) => {
          return this.filter.optionsPost.includes(
            element.item ? element.item.type : element.type
          );
        });
        result = [...req];
      
      if (this.filter.optionsPost.length === 0) {
        result = merged;
      }
      result = result.map((element) => {
        return {
          ...element,
          uId: uniqid(),
          feedType: feedType,
        };
      });

      return result.sort(this.lessItem);
    },

    filteredResults() {
      return this.filteredPostsResults;
    },

  },

  mounted() {
    if (this.$route.query.filter && this.$route.query.filter === "incoming") {
      this.startOption = "incoming";
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$refs.filterbar.destroy();
    next();
  },
  unmounted() {
    this.style.remove();
  },
};
</script>

<style lang="scss" scoped>
.cta-on-notification {
  max-height: 230px !important;
  max-width: 20% !important;
}
.content-display {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.notifications-list {
  width: 70%;
}
.content-container {
  width: 100%;
}
.header-spacer--standard {
  height: 100px;
}
</style>